import type { JSX } from "preact";

export function ButtonDivider(): JSX.Element {
    return <span className="btn-divider" />;
}
